import React from 'react';
import { useSelector } from 'react-redux';

// Types
import { IntegrationSources } from 'Shared/constants/IntegrationsList.constants';

// Components
import IntegrationsWrapper from 'Dashboard/components/IntegrationsWrapper/IntegrationsWrapper';

// Styles
import './UserNotificationsChatDisconnected.scss';

function UserNotificationsChatDisconnected() {
  const chatNotificationDestinations = useSelector(state =>
    state.notification_destinations.filter(({ is_chat }) => is_chat)
  );

  if (chatNotificationDestinations.find(({ connected }) => connected)) return null;

  return (
    <div className="UserNotificationsChatDisconnected">
      <IntegrationsWrapper
        filters={{
          showOnly: [IntegrationSources.SLACK, IntegrationSources.MICROSOFT_TEAMS, IntegrationSources.GOOGLE_CHAT],
        }}
      />
    </div>
  );
}

export default UserNotificationsChatDisconnected;
